(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');
    module.factory('TaskListService', ['$rootScope', 'Task', 'PaginationService', 'WebsocketService', 'WebsocketRegisterType', 'TaskBroadcast', 'DateService', 'TaskStateEnum', TaskListServiceFn]);

    /* main task service */
    function TaskListServiceFn($rootScope, Task, PaginationService, WebsocketService, WebsocketRegisterType, TaskBroadcast, DateService, TaskStateEnum) {

        var TaskListService = function () {
            // websocket subscriber
            var subAdd = null;
            var subDelete = null;
            var subUpdate = null;

            var data = {
                // service methods for websocket and pagination-service
                paginationService: new PaginationService([]),
                filter: {
                    agendaId: [], /// list of agenda-id
                    isToDo: false /// filter Daytasks ?
                }
            };


            /***
             * WebSocket Part and pagination-Service for general Handling in Views
             *
             */

            // register websocket call
            function registerWebsocket() {

                // listen on changes from tasks to update their daytask-list in quick-sidebar set

                // new task is added
                subAdd = WebsocketService.register(WebsocketRegisterType.TaskAdd, function (jObject) {
                    // add action
                    onAdd(jObject.data);
                });

                // existing one changed
                subUpdate = WebsocketService.register(WebsocketRegisterType.TaskUpdate, function (jObject) {
                    // update action
                    onUpdate(jObject.data);
                });

                // existing ones deleted
                subDelete = WebsocketService.register(WebsocketRegisterType.TaskDelete, function (jObject) {
                    // delete action
                    onRemove(jObject.data);
                });

            } // registerWebsocket 

            // clean service
            function clean() {
                if (subAdd) { WebsocketService.unregister(subAdd.id); }
                if (subUpdate) { WebsocketService.unregister(subUpdate.id); }
                if (subDelete) { WebsocketService.unregister(subDelete.id); }
                subAdd = null;
                subUpdate = null;
                subDelete = null;
                data.filter.agendaId = [];
                data.filter.isToDo = false;
                if (data.paginationService !== null) { data.paginationService.clean(); }
            }

            // add
            function onAdd(task) {
                // if agenda-id is in the list
                if (isWrong(task.fK_Agenda, task.isToDo)) { return; }

                // Add
                var added = add(task);
                if (added) {
                    adjustStateCount(added, 1);
                    adjustGrandTotal(1);
                }

                // update filters
                $rootScope.$broadcast(TaskBroadcast.RefreshFilter);
            } // add

            // delete
            function onRemove(task) {
                // if agenda-id is in the list
                if (isWrong(task.fK_Agenda, task.isToDo)) { return; }

                // remove task from list
                var removed = data.paginationService.remove(task);
                if (removed) {
                    adjustStateCount(removed, -1);
                    adjustGrandTotal(-1);
                }

                // update filters
                $rootScope.$broadcast(TaskBroadcast.RefreshFilter);
            } // remove

            // update
            function onUpdate(task) {
                // if agenda-id is in the list
                if (isWrong(task.fK_Agenda, task.isToDo)) { return; }

                // remove task and re-add
                var removedTask = data.paginationService.remove(task);
                if (removedTask) {
                    adjustStateCount(removedTask, -1);
                    adjustGrandTotal(-1);
                }

                // add new reaction to list
                //removedTask.reactions.push(task.reactions[0]);
                //task.reactions = removedTask.reactions;
                //removedTask = null;

                // Add
                var added = add(task);
                if (added) {
                    adjustStateCount(added, 1);
                    adjustGrandTotal(1);
                }

                // update filters
                $rootScope.$broadcast(TaskBroadcast.RefreshFilter);

            } // update


            // add to list
            function add(task) {
                // Right Date
                if (task.pinnedToDate !== null) {
                    // Check If Date Correct
                    if (!DateService.isSameDay(task.pinnedToDate, DateService.data.date)) { return null; }
                } // if

                // if task available -> insert
                if (typeof task !== 'undefined' && task !== null) {
                    var t = new Task();
                    t.extend(task);
                    // add to array -> beginning
                    data.paginationService.add(t);
                    return t;
                } //if

                return null;
            } // add

            // keep the backend-provided state counts (fe from getByAgendas) in sync with tasks
            // added/removed/updated locally via websocket, since those don't trigger a refetch
            function adjustStateCount(task, delta) {
                var counts = data.paginationService.data.stateCounts;
                if (!counts) { return; }

                var stateName = null;
                for (var key in TaskStateEnum) {
                    if (TaskStateEnum[key].value === task.vmTaskState) {
                        stateName = TaskStateEnum[key].name;
                        break;
                    }
                }
                if (!stateName) { return; }

                counts[stateName] = Math.max(0, (counts[stateName] || 0) + delta);
            } // adjustStateCount

            // keep the backend-provided grand total (fe from getByAgendas, over all pages) in sync
            // with tasks added/removed locally via websocket, since those don't trigger a refetch
            function adjustGrandTotal(delta) {
                var d = data.paginationService.data;
                if (typeof d.grandTotal !== 'number') { return; }

                d.grandTotal = Math.max(0, d.grandTotal + delta);
            } // adjustGrandTotal


            // is in id-list and/or type not the same ?
            function isWrong(id, isToDo) {
                // If we are in UGT -> show Ugts regardless agenda
                if (data.filter.isToDo === true) {
                    // We Only Filter If current task is NOT UGT
                    return data.filter.isToDo !== isToDo;
                } // if

                // check, if id is in the id-list
                return data.filter.agendaIds.indexOf(id) === -1 || data.filter.isToDo !== isToDo;
            } // filter

            // append a page of tasks (load-more) without resetting the existing list/filters
            function appendPage(tasks) {
                var items = [];
                var i = 0;
                var len = tasks.length;
                for (i = 0; i < len; i++) {
                    var t = new Task();
                    t.extend(tasks[i]);
                    items.push(t);
                } // for

                // append to the end of the existing (unfiltered) item list
                data.paginationService.data.items = data.paginationService.data.items.concat(items);
                data.paginationService.data.filteredItems = data.paginationService.data.items;
                data.paginationService.paginate();
            } // appendPage

            // init service
            function init(tasks, agendaIds, isToDo) {
                // clean
                clean();

                data.filter.agendaIds = agendaIds;
                data.filter.isToDo = isToDo === 'true' ? true : false;

                // prepare list of Tasks
                var items = [];
                var i = 0;
                var len = tasks.length;
                for (i = 0; i < len; i++) {
                    // new object
                    var t = new Task();
                    t.extend(tasks[i]);
                    // add to array
                    items.push(t);
                } // for

                // init pagination-service
                data.paginationService.init(items);

                // register Websocket
                registerWebsocket();

            } // init

            this.data = data;
            this.clean = clean;
            this.init = init;
            this.appendPage = appendPage;

        };
        return TaskListService;
    }
})();